import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
    EditRequestAssigneePayload,
    EditRequestPriorityPayload,
    EditRequestStatusPayload,
} from './cereri-detalii/actualizare-cerere/actualizare-cerere.interface';
import {
    extraActionCererePayload,
    IInchidereLucrare,
} from './cereri.interface';

@Injectable({
    providedIn: 'root',
})
export class CereriService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getCereriListDTURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.listDT;
    private getCerereURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.find;
    private addCerereURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.store;
    // private getOperatoriByCompartimentUrl =
    //     this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.getOperatoriByCompartiment;

    // Mesagerie
    private sablonContent = new Subject<string>();
    sablonContent$ = this.sablonContent.asObservable();
    private postMessageURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.postMessage;
    private rePostMessageURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.rePostMessage;
    private fileUploadUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.file.fileUpload;
    private fileUploadBase64Url =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.file.fileUploadBase64;

    // Actualizare cerere
    private updateStatusURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.updateStatus;
    private updatePriorityURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.updatePriority;
    private updateAssigneeURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.updateAssignee;
    private updateCetateanURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.updateCetatean;
    private updateProgramareConfigURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.updateProgramareConfig;
    private rescheduleURL =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.reschedule;

    // Actiuni cerere
    private validateCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.validateCerere;
    private invalidateCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.invalidateCerere;
    private anulareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.anulareCerere;
    private finalizareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.finalizareCerere;
    private preluarePersonalaUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.preluarePersonala;
    private preluareNumarRegistraturaUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.preluareNumarRegistratura;

    private resetValidareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetValidareCerere;
    private resetInvalidareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetInvalidareCerere;
    private resetClasareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetClasareCerere;
    private resetInchidereCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetInchidereCerere;

    // Prezență - Prezent/Absent
    private setPresentUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.setPresent;
    private setAbsentUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.setAbsent;
    private cancelSlotQuickUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.cancelSlotQuick;

    // Reset Prezență
    private resetPresentUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetPresent;
    private resetAbsentUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetAbsent;
    private resetCancelSlotUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetCancelSlot;
    private resetInvalidateUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.resetInvalidate;

    // Istoric programări cetățean
    private citizenHistoryUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.citizenHistory;

    // Altele
    public downloadDocumentUrl = this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.downloadDocument;

    constructor(private http: HttpClient) { }

    getCerere(id_cerere: number) {
        return this.http.get(this.getCerereURL + id_cerere);
    }

    // Mesagerie
    sendContent(content: string) {
        this.sablonContent.next(content);
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageURL + id, message, this.httpOptions);
    }

    rePostMessage(id: number) {
        return this.http.post(this.rePostMessageURL + id, this.httpOptions);
    }

    // Actualizare cerere
    updateRequestStatus(requestId: number, status: EditRequestStatusPayload) {
        return this.http.put(
            this.updateStatusURL + requestId,
            status,
            this.httpOptions
        );
    }

    updateRequestPriority(requestId: number, priority: EditRequestPriorityPayload) {
        return this.http.put(
            this.updatePriorityURL + requestId,
            priority,
            this.httpOptions
        );
    }

    updateRequestAssignee(requestId: number, data: EditRequestAssigneePayload) {
        return this.http.put(
            this.updateAssigneeURL + requestId,
            data,
            this.httpOptions
        );
    }

    updateCetatean(cerereId: number, data: any) {
        return this.http.put(
            this.updateCetateanURL + cerereId,
            data,
            this.httpOptions
        );
    }

    // Update configurație programare (tip problemă / tip program)
    updateProgramareConfig(cerereId: number, data: { id_problem_type?: number; id_program_type?: number }) {
        return this.http.put(
            this.updateProgramareConfigURL + cerereId,
            data,
            this.httpOptions
        );
    }

    // Reprogramare - schimbă slotul
    rescheduleAppointment(cerereId: number, data: { new_appointment_id: number }) {
        return this.http.post(
            this.rescheduleURL + cerereId,
            data,
            this.httpOptions
        );
    }

    // Actiuni cerere
    validateCerere(cerereId: number) {
        return this.http.post(this.validateCerereUrl + cerereId, this.httpOptions);
    }

    invalidateCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.invalidateCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    anulareCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.anulareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    finalizareCerere(cerereId: number, data: IInchidereLucrare) {
        return this.http.post(
            this.finalizareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    preluarePersonala(cerereId: number) {
        return this.http.get(this.preluarePersonalaUrl + cerereId);
    }

    preluareNumarRegistratura(cerereId: number) {
        return this.http.put(this.preluareNumarRegistraturaUrl + cerereId, {});
    }

    resetValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetValidareCerereUrl + cerereId, data);
    }

    resetInvalidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetInvalidareCerereUrl + cerereId, data);
    }

    resetClasareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetClasareCerereUrl + cerereId, data);
    }

    resetInchidereCerere(cerereId: number, data: any) {
        return this.http.post(this.resetInchidereCerereUrl + cerereId, data);
    }

    // Prezență - Prezent/Absent
    setPresent(cerereId: number, data: any) {
        return this.http.post(this.setPresentUrl + cerereId, data, this.httpOptions);
    }

    setAbsent(cerereId: number, data: any) {
        return this.http.post(this.setAbsentUrl + cerereId, data, this.httpOptions);
    }

    cancelSlotQuick(cerereId: number, data: any) {
        return this.http.post(this.cancelSlotQuickUrl + cerereId, data, this.httpOptions);
    }

    // Reset Prezență
    resetPresent(cerereId: number, data: any) {
        return this.http.post(this.resetPresentUrl + cerereId, data, this.httpOptions);
    }

    resetAbsent(cerereId: number, data: any) {
        return this.http.post(this.resetAbsentUrl + cerereId, data, this.httpOptions);
    }

    resetCancelSlot(cerereId: number, data: any) {
        return this.http.post(this.resetCancelSlotUrl + cerereId, data, this.httpOptions);
    }

    resetInvalidate(cerereId: number, data: any) {
        return this.http.post(this.resetInvalidateUrl + cerereId, data, this.httpOptions);
    }

    // Istoric programări cetățean
    getCitizenHistory(cerereId: number) {
        return this.http.get<any>(this.citizenHistoryUrl + cerereId);
    }

    // Altele

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}